// extracted by mini-css-extract-plugin
export default {"active":"Footer_active__fBJKb","bottom-menu":"Footer_bottom-menu__e4bNi","navlink":"Footer_navlink__YGNth","tab":"Footer_tab__mNTQ1"};